import { metaTagService } from '../services/metaTagService';

export const processTagPayload = async (rawTags = []) => {
  if (!Array.isArray(rawTags) || rawTags.length === 0) return [];

  const existingTagIds = [];
  const tagNames = [];
  const newTags = [];

  rawTags.forEach((tag) => {
    if (!tag) return;

    if (typeof tag === 'number') {
      existingTagIds.push(tag);
      return;
    }

    if (typeof tag === 'string') {
      const trimmed = tag.trim();
      if (!trimmed) return;
      if (/^\d+$/.test(trimmed)) {
        existingTagIds.push(Number(trimmed));
      } else {
        tagNames.push(trimmed);
      }
      return;
    }

    if (typeof tag === 'object') {
      if (tag._isNew === true) {
        newTags.push(tag);
      } else if (typeof tag.id === 'number' && tag.id > 0) {
        existingTagIds.push(tag.id);
      } else if (typeof tag.name === 'string' && tag.name.trim()) {
        tagNames.push(tag.name.trim());
      }
    }
  });

  const resolveExistingTagIdsByName = async (names) => {
    if (!names.length) return [];
    try {
      metaTagService.clearCache();
      const allTags = await metaTagService.getActiveTags();
      const list = Array.isArray(allTags) ? allTags : (allTags?.results || []);
      return names
        .map((name) =>
          list.find((tag) => String(tag.name).trim().toLowerCase() === String(name).trim().toLowerCase())?.id
        )
        .filter((id) => typeof id === 'number' && id > 0);
    } catch (error) {
      console.error('Failed to resolve tag names:', error);
      return [];
    }
  };

  const resolvedNameIds = await resolveExistingTagIdsByName(tagNames);
  const createdTagIds = [];

  for (const newTag of newTags) {
    const name = typeof newTag.name === 'string' ? newTag.name.trim() : '';
    if (!name) continue;

    try {
      const createdTag = await metaTagService.create({
        name,
        color: newTag.color || '#1976d2',
        is_active: true,
      });
      if (createdTag?.id) {
        createdTagIds.push(createdTag.id);
      }
    } catch (error) {
      console.error('Failed to create tag:', name, error);
      const fallbackIds = await resolveExistingTagIdsByName([name]);
      createdTagIds.push(...fallbackIds);
    }
  }

  if (createdTagIds.length > 0) {
    metaTagService.clearCache();
  }

  return [...new Set([...existingTagIds, ...resolvedNameIds, ...createdTagIds])]
    .filter((id) => typeof id === 'number' && !Number.isNaN(id) && id > 0);
};
